/**
 * @generated SignedSource<<1f79aa7355ca8fd554ef0a482f955d83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorAvatarsArticle$data = {
  readonly authors: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor" | "entityFollowButtonBase">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "authorAvatarsArticle";
};
export type authorAvatarsArticle$key = {
  readonly " $data"?: authorAvatarsArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorAvatarsArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorAvatarsArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "authorAvatarAuthor"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityFollowButtonBase"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "410c94d33e7e294e6127e4b9e033946e";

export default node;
